(function(module) {
    'use strict';

    function appPreviewWrapperCtrl(App, AppTemplate, Includes, Store, $scope, $http, $q, $timeout, WS, envService, fetchAppTemplate) {
        this.dynamicFetchTracker = createDynamicFetchTracker();
        this.previewData = createPreviewDataSource(null);
        this.effectiveDynamic = null;

        this.$onInit = () => {
            this.loaded = false;
            this.records = [];
            this.APPS_URI = envService.read('APPS_URI');
            this.CUSTOM_APPS_URI = envService.read('CUSTOM_APPS_URI');
            this.SLS_URI = envService.read('SLS_URI');
            this.SERVICES_URI =  envService.read('SERVICES_URI');
            this.PLAYER_URI = envService.read('PLAYER_URI');

            if (this.mode !== 'view') {
                $scope.$watchGroup(['$ctrl.app.data.feed', '$ctrl.loaded'], ([ feed, loaded ]) => {
                    // News Apps
                    if (loaded && feed && this.appTemplate && this.appTemplate.integrationTemplate === 'rocket-news-rss') {
                        this.getFeed(feed);
                    }
                });

                $scope.$watch('$ctrl.app.data', (data) => {
                    if (this.loaded && data) {

                        if (this.previewData.isSample()) {
                            if (this.dynamicFetchTracker.shouldFetch(
                                this.appTemplate, data, this.currentIntegrationId(),
                            )) {
                                this.setLiveDynamic([]);
                            }
                            this.effectiveDynamic = this.previewData.refreshSample(
                                this.appTemplate.slug,
                                data,
                            );
                            return;
                        }

                        // iframe apps: www, google-slides
                        if (this.appTemplate.type === 'iframe') {
                            this.src = this.getUrlFromIframeApp(this.appTemplate, { data, settings: this.app.settings });
                        }

                        // Per-app readiness for a live feed fetch lives in the pure
                        // shouldFetchDynamic() helper (was inline per-slug ifs flagged
                        // "hard-coding app specific logic - this must be moved").
                        // Covers twitter-hashtag/twitter-timeline/dropbox-gallery/
                        // message-board and, from #561, achievers + workday.
                        // #617 — an integration app is not ready until an account
                        // is selected; fetching earlier sends an unauthenticated
                        // request and consumes the tracker key, suppressing the
                        // real one. The integrationId watch below covers that case.
                        if (!this.isReadyForDynamicFetch()) return;

                        if (this.dynamicFetchTracker.shouldFetch(
                            this.appTemplate, data, this.currentIntegrationId(),
                        )) {
                            this.getDynamic(data);
                        }
                    }
                }, true);

                // #617 — selecting an integration changes only app.integrationId,
                // which neither the data nor settings watch observes. Without this
                // the seeded default never reaches the upstream feed.
                $scope.$watch('$ctrl.app.integrationId', () => {
                    if (!this.loaded) return;
                    this.fetchDynamicForCurrentData();
                });

                $scope.$watch('$ctrl.app.settings', (settings) => {
                    if (this.loaded && settings) {
                        // iframe apps: www, google-slides
                        if (this.appTemplate.type === 'iframe') {
                            this.src = this.getUrlFromIframeApp(this.appTemplate, { data: this.app.data, settings });
                        }
                    }
                }, true);
            }

        };

        this.setLiveDynamic = (body) => {
            this.dynamic = body;
            this.effectiveDynamic = this.previewData.acceptLive(body);
        };

        this.applyPreviewDataSource = ({ forceLive = false } = {}) => {
            if (!this.appTemplate) return;

            if (this.previewDataSource === 'sample') {
                this.effectiveDynamic = this.previewData.useSample(
                    this.appTemplate.slug,
                    _.get(this.app, 'data', {}),
                    this.samplePreviewNow,
                );
                this.onError({ $event: { name: 'preview', value: null } });
                return;
            }

            this.previewData.acceptLive(this.dynamic);
            this.effectiveDynamic = this.previewData.useLive();
            // #617 — a forced Live refresh bypassed the readiness gate, so
            // switching to Sample and back before choosing an account fired an
            // unauthenticated request AND primed the tracker, suppressing the
            // real request once the account was selected.
            if (forceLive && this.isReadyForDynamicFetch()) {
                this.dynamicFetchTracker.prime(
                    this.appTemplate, _.get(this.app, 'data', {}), this.currentIntegrationId(),
                );
                this.getDynamic(_.get(this.app, 'data', {}));
            }
        };

        // The account the upstream request is made against. getDynamic() prefers
        // the bound integration and falls back to the app's own id, so key
        // identity has to resolve it the same way.
        this.currentIntegrationId = () => (
            (this.integration && this.integration.id)
            || _.get(this.app, 'integrationId')
            || _.get(this.app, 'integration.id')
            || null
        );

        this.isReadyForDynamicFetch = () => isReadyForDynamicFetch(
            this.appTemplate,
            this.app,
            this.integration,
        );

        this.fetchDynamicForCurrentData = () => {
            if (!this.isReadyForDynamicFetch()) return;
            const data = _.get(this.app, 'data');
            if (shouldFetchDynamicForCurrentData(
                this.previewDataSource,
                this.appTemplate,
                data,
                this.dynamicFetchTracker,
                this.currentIntegrationId(),
            )) {
                this.getDynamic(data);
            }
        };

        this.getCache = app => $q(resolve => {
            const appId = _.get(app, 'id', null);
            const appTemplateType = _.get(app, 'appTemplate.type', null);
            if (appId && appTemplateType && appTemplateType === 'integration') {
                $http({
                    method: 'GET',
                    url: `${this.SLS_URI}/apps/${appId}`,
                })
                    .then(({ data }) => {
                        $timeout(() => {
                            this.cache = data;
                            $scope.$apply();
                        });
                    })
                    .catch((error) => {
                        console.log('Preview getCache error', error);
                        this.cache = this.cache || [];
                    }).finally(() => {
                    resolve();
                });
            } else {
                this.cache = [];
                resolve();
            }
        });

        this.getDynamic = (data) => {
            const requestedData = _.cloneDeep(data);
            // if new app should have existing integration, otherwise figure it out
            const integration = (this.integration && this.integration.id)
                ? this.integration
                : Store.getSingleModelData('integrations', _.get(this.app, 'integrationId'));
            // Snapshot the account this request is for, so a late response can be
            // matched against whatever is selected by the time it lands. The
            // generation additionally separates two requests for the SAME account
            // and data (A -> B -> A), which the key alone cannot tell apart.
            const requestedIntegrationId = this.currentIntegrationId();
            this.dynamicRequestGeneration = (this.dynamicRequestGeneration || 0) + 1;
            const requestedGeneration = this.dynamicRequestGeneration;

            $timeout(() => {
                this.setLiveDynamic([]);
                $scope.$apply();
            });

            $http({
                method: 'GET',
                params: { data, credentials: integration && integration.credentials, integrationId: integration && integration.id },
                url: `${this.SLS_URI}/preview/${this.appTemplate.slug}`,
            })
                .then(({ data: body }) => {
                    // #617 — compare the account too, so a response for the
                    // previously selected account is discarded rather than shown
                    // under the new one.
                    if (!shouldAcceptDynamicResponse(
                        this.appTemplate,
                        requestedData,
                        _.get(this.app, 'data', {}),
                        {
                            requested: requestedIntegrationId,
                            current: this.currentIntegrationId(),
                            requestedGeneration,
                            currentGeneration: this.dynamicRequestGeneration,
                        },
                    )) return;
                    this.onError({ $event: { name: 'preview', value: null } });
                    this.setLiveDynamic(body);
                })
                .catch((error) => {
                    if (!shouldPublishDynamicError(
                        this.appTemplate,
                        requestedData,
                        _.get(this.app, 'data', {}),
                        this.previewData.isSample(),
                        {
                            requested: requestedIntegrationId,
                            current: this.currentIntegrationId(),
                            requestedGeneration,
                            currentGeneration: this.dynamicRequestGeneration,
                        },
                    )) return;
                    if (this.appTemplate.slug === 'dropbox-gallery') {
                        if (error && error.status === 409) this.onError({ $event: { name: 'preview', value: `Sorry, we could not find this folder. Please check if such a folder exists in your Dropbox: "Apps/SignageRocket/${data.folder}"` } });
                    } else {
                        this.onError({ $event: { name: 'preview', value: 'Sorry, we could not get the data you asked for. Please try another value' } });
                    }
                    console.log('Preview getDynamic error', error);
                });
        };

        this.getFeed = (feed) => {
            $timeout(() => {
                this.setLiveDynamic([]);
                $scope.$apply();
            });
            const provider = this.appTemplate.slug.replace('-news', '');
            const url = `${this.SERVICES_URI}/feeds/preview/${provider}/${feed}`;

            $http({
                method: 'GET',
                url,
            })
                .then(({ data }) => {
                    this.onError({ $event: { name: 'preview', value: null } });;
                    this.setLiveDynamic(data);
                    this.cache = data;
                })
                .catch((error) => {
                    this.onError({ $event: { name: 'preview', value: 'Sorry, we could not get the data you asked for. Please try another value' } });
                    console.log('Preview getDynamic error', error);
                });
        };

        this.getUrlFromIframeApp = (appTemplate, app) => {
            if (app && app.data) {

                if (appTemplate.slug === 'google-slides' && app.data.url) {
                    return app.data.url.replace('/pub?', '/embed?rm=minimal&');
                }

                // if (appTemplate.slug === 'www' && app.data.username && app.data.password) {
                //     return `${this.SLS_URI}/http-basic-auth/${app.id}`;
                // }

                const URL = _.get(app, 'data.url', null);
                return (URL && URL.includes('https://') || URL && URL.includes('http://')) ? URL : null;
            }
        };

        this.buildSrc = (appTemplate) => {
            const { id, slug, type, appSource, realm, version, accountId } = (appTemplate || {});

            if (type === 'iframe') return this.getUrlFromIframeApp(appTemplate, this.app);
            if (appSource) return appSource;

            const SLUG =  slug || realm;
            switch (realm) {
                // OLD CUSTOM
                // case 'custom':
                //     return `${this.CUSTOM_APPS_URI}/account-${accountId}/app-template-${id}/version-${version}/index.html?version=${version}`;
                case 'rocket': {
                    const accountIdFromCookie = Store.getCurrentAccountId();
                    return `${this.PLAYER_URI}/#/preview/${SLUG}?preview=true&accountId=${accountIdFromCookie}&realm=${realm}&id=${id}&version=${version}`;
                }
                case 'custom': {
                    const accountIdFromCookie = Store.getCurrentAccountId();
                    return `${this.PLAYER_URI}/#/preview/${SLUG}?preview=true&accountId=${accountIdFromCookie}&realm=${realm}&id=${id}&version=${version}`;
                }
                default:
                    return `${this.APPS_URI}/${SLUG}/index.html`;
            }
        };

        this.setSrcFromApp = (app) => {
            this.src = this.buildSrc(_.get(app, 'appTemplate', {}));
            // return to continue in the promise chain
            return app;
        };

        this.setSrcFromAppTemplate = (appTemplate) => {
            this.src = this.buildSrc(appTemplate);
            // return to continue in the promise chain
            return appTemplate;
        };

        this.getAppById = (appId) => {
            const appFromStore = Store.getSingleModelData('apps', appId);
            if (!appFromStore) {
                return App.findById({ id: appId, filter: Includes.apps }).$promise;
            } else {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve(appFromStore);
                });
                return deferred.promise;
            }
        };

        this.setApp = (app) => {
            this.app = app;
            this.dynamicFetchTracker.prime(app.appTemplate, app.data, this.currentIntegrationId());
            this.appTemplate = app.appTemplate;
            this.previewData.acceptLive(this.dynamic);

            if (app.appTemplate.live) this.subscribeToCustomAppVersionChange(app.appTemplate.id);
            // return to continue in the promise chain
            return app;
        };

        this.getAppTemplateById = (appTemplateId) => {
            return fetchAppTemplate(appTemplateId, { AppTemplate });
        };

        this.setAppTemplate = (appTemplate) => {
            this.dynamicFetchTracker.reset();
            this.appTemplate = appTemplate;
            if (appTemplate.live) this.subscribeToCustomAppVersionChange(appTemplate.id);

            return appTemplate;
        };

        this.$onDestroy = () => {
            if (this.appId) {
                const name = `app:${this.appId}:dynamic`;
                WS.event.unsubscribe(name);
            }
            _.each(this.records, (record) => {
                record.unsubscribe();
                record.discard();
            });
        };

        this.subscribeToDynamicData = (appId) => {
            const eventName = `app:${appId}:dynamic`;
            WS.event.subscribe(eventName, (message) => {
                $timeout(() => {
                    this.setLiveDynamic(message);
                    $scope.$apply();
                });
            });
        };

        this.subscribeToCustomAppVersionChange = (appTemplateId) => {
            const recordName = `appTemplate:${appTemplateId}`;
            WS.record.getRecord(recordName).whenReady((record) => {
                record.subscribe(() => {
                    this.onCustomTemplateVersionChange();
                });
                this.records.push(record);
            });
        };

        this.onCustomTemplateVersionChange = () => {
            this.loaded = false;
            this.getAppTemplateById(this.appTemplate.id)
                .then(this.setAppTemplate)
                .then(this.setSrcFromAppTemplate)
                .then(() => {
                    this.loaded = true;
                    this.applyPreviewDataSource();
                    this.fetchDynamicForCurrentData();
                });
        };

        this.$onChanges = ({ appId, appTemplateId, previewRequestId }) => {
            if (previewRequestId && !previewRequestId.isFirstChange()) {
                this.applyPreviewDataSource({ forceLive: this.previewDataSource === 'live' });
            }

            // on edit screen use app or on display view
            if (this.mode === 'edit' && appId && appId.currentValue || this.mode === 'view' && appId && appId.currentValue) {
                if (appId.previousValue.length && appId.currentValue !== appId.previousValue) {
                    const name = `app:${appId.previousValue}:dynamic`;
                    WS.event.unsubscribe(name);
                    this.loaded = false;
                }

                this.getAppById(appId.currentValue)
                    .then(this.setApp)
                    .then(this.setSrcFromApp)
                    .then(this.getCache)
                    .then(() => {
                        this.loaded = true;
                        this.subscribeToDynamicData(appId.currentValue);
                        this.applyPreviewDataSource();
                    });
            }

            // new app screen
            if (this.mode === 'add' && appTemplateId && appTemplateId.currentValue) {
                if (appTemplateId.previousValue.length && appTemplateId.currentValue !== appTemplateId.previousValue) {
                    this.loaded = false;
                }

                this.getAppTemplateById(appTemplateId.currentValue)
                    .then(this.setAppTemplate)
                    .then(this.setSrcFromAppTemplate)
                    .then(() => {
                        this.cache = this.cache ? this.cache : [];
                        this.loaded = true;
                        this.applyPreviewDataSource();
                        this.fetchDynamicForCurrentData();
                    });
            }
        };
    }

    module
        .component('appPreviewWrapper', {
            controller: appPreviewWrapperCtrl,
            templateUrl: '/js/components/app-preview-wrapper/app-preview-wrapper.html',
            bindings: {
                mode: '@',
                appId: '@',
                appTemplateId: '@',

                app: '=',
                cache: '=',
                dynamic: '=',
                previewDataSource: '<',
                previewRequestId: '<',
                samplePreviewNow: '<',
                onError: '&',
            },
        });

})(angular.module('rocket.components'));
